export default "__VITE_ASSET__CTzQ3u5g__"